/* eslint-disable jsx-a11y/accessible-emoji */
import React from "react";
import {
  BorderContainer,
  Subtitle,
  Container,
  Button,
  MainTitle,
} from "../mainStyles";

const PopupError2 = () => {

  return (
    <BorderContainer>
      <Container style={{ height: "35rem" }} id="popupError">
        <MainTitle style={{ textAlign: "center" }} id="createNewC">
          Seems like a mistake
        </MainTitle>
        <Subtitle style={{ textAlign: "center" }}>
          Your URL is not correct. Please create new canvas.
        </Subtitle>

        <Button
          style={{ margin: "auto", marginBottom: "0.5rem" }}
          id="btnReload"
          href="/"
        >
          Create new canvas
        </Button>
      </Container>
    </BorderContainer>
  );
};

export default PopupError2;
